<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <h1 *ngIf="!isEdit" class="text-center lifedi-color mb-5">
    สร้างรูปแบบรายงาน
  </h1>
  <h1 *ngIf="isEdit" class="text-center lifedi-color mb-5">
    แก้ไขรูปแบบรายงาน
  </h1>

  <div class="row d-flex justify-content-center">
    <div class="col-8">
      <div class="form-group row p-0 d-flex justify-content-center">
        <label class="col-3 col-form-label">รูปแบบรายงาน</label>
        <div class="col-6">
          <select class="custom-select form-control float-left" style="width: 100%;" [(ngModel)]="reportType"
            (change)="changeType(reportType)">
            <option value="" selected hidden disabled></option>
            <option value="spider">Spider</option>
            <option value="profile">Profile</option>
            <option value="standard">Normal Distribution</option>
            <option value="4box">Classification Table</option>
            <option value="profile_matching">Profile Matching</option>
            <option value="toprank">Top rank</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- not edit -->
  <div *ngIf="!isEdit || !reportDetail">
    <!-- profile and standard -->
    <div *ngIf="reportType === 'profile'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-template>
      </div>
    </div>

    <div *ngIf="reportType === 'standard'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-template>
      </div>
    </div>

    <!-- spider -->
    <div *ngIf="reportType === 'spider'">
      <div [formGroup]="reportForm">
        <lifedi-report-spider-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-spider-template>
      </div>
    </div>

    <!-- 4-Box -->
    <div *ngIf="reportType === '4box'">
      <div [formGroup]="reportForm">
        <lifedi-report-four-box-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-four-box-template>
      </div>
    </div>

    <div *ngIf="reportType === 'profile_matching'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-matching-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-matching-template>
      </div>
    </div>

    <div *ngIf="reportType === 'toprank'">
      <div [formGroup]="reportForm">
        <lifedi-report-top-rank-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-top-rank-template>
      </div>
    </div>
  </div>
  <!-- not edit -->

  <!-- edit -->
  <div *ngIf="isEdit && reportDetail">
    <div *ngIf="reportType === 'profile'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-template>
      </div>
    </div>

    <div *ngIf="reportType === 'standard'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-template>
      </div>
    </div>

    <div *ngIf="reportType === 'spider'">
      <div [formGroup]="reportForm">
        <lifedi-report-spider-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-spider-template>
      </div>
    </div>

    <div *ngIf="reportType === '4box'">
      <div [formGroup]="reportForm">
        <lifedi-report-four-box-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-four-box-template>
      </div>
    </div>

    <div *ngIf="reportType === 'profile_matching'">
      <div [formGroup]="reportForm">
        <lifedi-report-profile-matching-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-profile-matching-template>
      </div>
    </div>

    <div *ngIf="reportType === 'toprank'">
      <div [formGroup]="reportForm">
        <lifedi-report-top-rank-template [reportForm]="reportForm" [reportType]="reportType" [isPaid]="isPaid"
          [isEdit]="isEdit" [reportID]="reportID" [measureID]="measureID">
        </lifedi-report-top-rank-template>
      </div>
    </div>

  </div>
  <!-- edit -->


  <div *ngIf="reportType" class="row d-flex justify-content-center">

    <div *ngIf="reportType !== 'toprank'">
      <lifedi-btn *ngIf="reportForm.valid" (click)="manageData(reportForm.value, reportType)" lable="บันทึก"
        customStyle="background-color: #005C3D; color: #FFF; margin: 10px; padding: 0 30px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!reportForm.valid " lable="บันทึก" disabled="true"
        customStyle="background-color: #B6B6B6; color: #FFF; margin: 10px; padding: 0 30px;">
      </lifedi-btn>
    </div>

    <div *ngIf="reportType === 'toprank'">

      <lifedi-btn *ngIf="reportForm.valid && reportForm.value.PSY_BLOCKS.length >= reportForm.value.NUMBER_OF_RANK"
        (click)="manageData(reportForm.value, reportType)" lable="บันทึก"
        customStyle="background-color: #005C3D; color: #FFF; margin: 10px; padding: 0 30px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="!reportForm.valid" lable="บันทึก" disabled="true"
        customStyle="background-color: #B6B6B6; color: #FFF; margin: 10px; padding: 0 30px;">
      </lifedi-btn>
      <lifedi-btn *ngIf="reportForm.value.PSY_BLOCKS.length < reportForm.value.NUMBER_OF_RANK" lable="บันทึก" disabled="true"
        customStyle="background-color: #B6B6B6; color: #FFF; margin: 10px; padding: 0 30px;">
      </lifedi-btn>
    </div>

  </div>
</div>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>